/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addTaxRate } from '../fn/tax-rate-v-2/add-tax-rate';
import { AddTaxRate$Params } from '../fn/tax-rate-v-2/add-tax-rate';
import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { TaxRatesV2Dto as DigiworkMaitreDPosDtoTaxRatesV2TaxRatesV2Dto } from '../models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rates-v-2-dto';
import { TaxRateV2Dto as DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto } from '../models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';
import { getTaxRate } from '../fn/tax-rate-v-2/get-tax-rate';
import { GetTaxRate$Params } from '../fn/tax-rate-v-2/get-tax-rate';
import { getTaxRates } from '../fn/tax-rate-v-2/get-tax-rates';
import { GetTaxRates$Params } from '../fn/tax-rate-v-2/get-tax-rates';
import { removeTaxRate } from '../fn/tax-rate-v-2/remove-tax-rate';
import { RemoveTaxRate$Params } from '../fn/tax-rate-v-2/remove-tax-rate';
import { updateTaxRate_1 } from '../fn/tax-rate-v-2/update-tax-rate-1';
import { UpdateTaxRate_1$Params } from '../fn/tax-rate-v-2/update-tax-rate-1';

@Injectable({ providedIn: 'root' })
export class TaxRateV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTaxRates()` */
  static readonly GetTaxRatesPath = '/api/tax-rates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTaxRates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTaxRates$Response(params?: GetTaxRates$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRatesV2Dto>> {
    return getTaxRates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTaxRates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTaxRates(params?: GetTaxRates$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoTaxRatesV2TaxRatesV2Dto> {
    return this.getTaxRates$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRatesV2Dto>): DigiworkMaitreDPosDtoTaxRatesV2TaxRatesV2Dto => r.body)
    );
  }

  /** Path part for operation `addTaxRate()` */
  static readonly AddTaxRatePath = '/api/tax-rates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTaxRate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTaxRate$Response(params?: AddTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>> {
    return addTaxRate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addTaxRate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTaxRate(params?: AddTaxRate$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto> {
    return this.addTaxRate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>): DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto => r.body)
    );
  }

  /** Path part for operation `getTaxRate()` */
  static readonly GetTaxRatePath = '/api/tax-rates/{taxRateId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTaxRate()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTaxRate$Response(params: GetTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>> {
    return getTaxRate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTaxRate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTaxRate(params: GetTaxRate$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto> {
    return this.getTaxRate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>): DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto => r.body)
    );
  }

  /** Path part for operation `updateTaxRate_1()` */
  static readonly UpdateTaxRate_1Path = '/api/tax-rates/{taxRateId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTaxRate_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTaxRate_1$Response(params: UpdateTaxRate_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>> {
    return updateTaxRate_1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTaxRate_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTaxRate_1(params: UpdateTaxRate_1$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto> {
    return this.updateTaxRate_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>): DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto => r.body)
    );
  }

  /** Path part for operation `removeTaxRate()` */
  static readonly RemoveTaxRatePath = '/api/tax-rates/{taxRateId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeTaxRate()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeTaxRate$Response(params: RemoveTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return removeTaxRate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeTaxRate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeTaxRate(params: RemoveTaxRate$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.removeTaxRate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

}
